<template>
   <div class="">
    <router-link :to="{name: 'salesDetails', query: {branchId: data.branchId, date: data.date, branchName: data.branchName, saleId: data.id, ...$route.query}}" class="btn dealers_btn mr-3"  style="font-size: 15px">
      {{$t('text.clickButtons.viewDetails')}}
    </router-link> 
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
  },
  methods: {
      
      
  },
};

</script>